module.exports = __webpack_public_path__ + "static/media/instragram6.03ea79b2.jpg";